import { Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslatedToastService {
  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  async show(
    type: 'success' | 'error' | 'info' | 'warning',
    messageKey: string,
    titleKey?: string,
    params?: Object,
    options?: Partial<IndividualConfig>,
  ): Promise<ActiveToast<any>> {
    const message = await firstValueFrom(
      this.translate.get(messageKey, params),
    );
    const title = titleKey
      ? await firstValueFrom(this.translate.get(titleKey, params))
      : undefined;

    return this.toastr[type](message, title, options);
  }
}
